export default __webpack_public_path__ + "static/media/what-we-offers-01.bbcb17ed.jpg";